import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { max, startOfMonth, startOfWeek } from "date-fns";
import { formatDateTickValue } from "utilities/format-date-tick-value";

/**
 * Tick formatter for the first X axis of a date time chart.
 * @param startDateTime
 * @param tickValue
 * @param timePeriodGroup
 */
export const dateTimeUpperXAxisTickFormatter = (
    startDateTime: Date,
    tickValue: any,
    timePeriodGroup: TimePeriodGroupBy
) => {
    if (tickValue instanceof Date || typeof tickValue === "number") {
        if (timePeriodGroup === TimePeriodGroupBy.Weeks) {
            return formatDateTickValue(
                max([startOfWeek(tickValue, { weekStartsOn: 1 }), startDateTime]),
                timePeriodGroup
            );
        }

        if (timePeriodGroup === TimePeriodGroupBy.Months) {
            return formatDateTickValue(max([startOfMonth(tickValue), startDateTime]), timePeriodGroup);
        }
        return formatDateTickValue(tickValue, timePeriodGroup);
    }
    return tickValue;
};
